import React, { useEffect, useState } from 'react';

import { DashboardLayout, Button, Spinner } from "components";

import { 
    useAlertMessage,
    useCompanyInputs, useProductInputs, 
    useChargeInputs, useMiscellaneousInputs,
    useSubmission,
} from "./hooks";

import "assets/scss/billingPortal/modules/advancePay/accountUpdate.scss";
import { useSideInputDisplay } from './hooks/useSideInputDisplay';
import { getStringUniqueId, getWindowHeight } from 'functions';
import { useOnPageExit } from 'hooks/useOnPageExit';



export default function AccountUpdate(props) {    
    // Props  
    const { 
        isEditing, 
        isAccountRecordUpdateRequesting: isLoading,
    } = props;

    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);
    const [inputWrapperID] = useState(getStringUniqueId("input-wrapper"));
    const [headerID] = useState(getStringUniqueId("header"));

    // Page Header
    let pageHeaderTitle = isEditing? "Edit Account": "Add Account";


    useEffect(() => {
        let headerEle = document.getElementById(headerID);
        let inputWrapperEle = document.getElementById(inputWrapperID);

        let headerRect = headerEle?.getBoundingClientRect();
        inputWrapperEle.style.height = (getWindowHeight() - headerRect?.bottom - 25) + "px"; // 25px is because of padding bottom
    }, [])

    /* Hooks */

    // Alert Message
    const {
        alertMessageDisplay, setAlertMsg
    } = useAlertMessage({
        ...props,
        isFormSubmissionAttempted
    })

    // Company
    const { 
        companyId,
        companyDetails,
        isEveryInputValid: isEveryInputValid_company,
        display: companyInputDisplay,
        isAnyInputChanged: isAnyInputChanged_company
    } = useCompanyInputs({
        ...props, 
        isFormSubmissionAttempted, 
    });

    // Charge
    const { 
        chargeDetails,

        isEveryInputValid: isEveryInputValid_charge,
        isAnyInputChanged: isAnyInputChanged_charge,
        display: chargeInputDisplay
    } = useChargeInputs({
        ...props, 
        isFormSubmissionAttempted,
    });
    
    // Product
    const { 
        productCode, isDefaultProduct, productDetails,
        isEveryInputValid: isEveryInputValid_product,
        display: productInputDisplay,
        isAnyInputChanged: isAnyInputChanged_product
    } = useProductInputs({
        ...props, 
        isFormSubmissionAttempted,
    });

    // Miscellaneous
    const { 
        miscellaneousDetails,

        isEveryInputValid: isEveryInputValid_miscellaneous,
        display: miscellaneousInputDisplay, 
        isAnyInputChanged: isAnyInputChanged_miscellaneous
    } = useMiscellaneousInputs({
        ...props, 
        isFormSubmissionAttempted, 
        isDefaultProduct,
        chargeDetails
    });

    const {
        sideDetails,

        isEveryInputValid: isEveryInputValid_side,
        display: sideInputDisplay, 
        isAnyInputChanged: isAnyInputChanged_side
    } = useSideInputDisplay({
        ...props,
        isFormSubmissionAttempted
    });

    // Input Check
    let isEveryInputValid = (
        isEveryInputValid_company &&
        isEveryInputValid_product &&
        isEveryInputValid_charge &&
        isEveryInputValid_miscellaneous &&
        isEveryInputValid_side   
    );
    let isAnyInputChanged = isAnyInputChanged_company || isAnyInputChanged_product || 
        isAnyInputChanged_charge || isAnyInputChanged_miscellaneous || isAnyInputChanged_side;

    // Submission
    const {
        submitIcon, submitText, submitAltText,
        handleSubmission
    } = useSubmission({
        ...props,

        isEveryInputValid, isAnyInputChanged,

        productCode, companyId,

        companyDetails, productDetails,
        chargeDetails, miscellaneousDetails,
        sideDetails,

        isFormSubmissionAttempted, setFormSubmissionStatus,
        setAlertMsg
    })
    

    // Handle Page Exit
    const {
        handleHideFormPage,
        pageExitModal
    } = useOnPageExit({
        ...props,
        handleSubmission,
        isAnyInputChanged,
        isEveryInputValid
    });

    return (
        <DashboardLayout
            headerTitle={pageHeaderTitle}
            
            onClose={(isAnyInputChanged)? handleHideFormPage: null}
            isHeaderCloseIconVisible

            bodyClassName={"advance-pay-setup-account-update"}
            body={(
                <React.Fragment>
                    {/* Page Exit Alert */}
                    {pageExitModal}

                    <div id={headerID} className="advance-pay-setup-account-update__sub-header d-flex justify-content-between">
                        {/* Title */}
                        <span className={"sub-header__title"}>{isEditing? "Update Info": "Insert Info"}</span>

                        {/* Action */}
                        <Button
                            className={"sub-header__action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {isLoading? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={submitIcon}
                                        alt={submitAltText}
                                        className={"action__icon"}
                                    />
                                )}
                                <div className={"action__text"}>
                                    {submitText}
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div id={inputWrapperID} className="advance-pay-setup-account-update__input-wrapper">
                        {/* Alert Error Messages */}
                        {alertMessageDisplay}
                        
                        <div className={"d-flex h-100"}>
                            <div className={"input-wrapper__left-section"}>
                                {/* Company Info */}
                                <div className={"left-section__input"}>
                                    {companyInputDisplay}
                                </div>

                                {/* Product Info */}
                                <div className={"left-section__input"}>
                                    {productInputDisplay}
                                </div>
                    
                                {/* Charge Info */}
                                <div className={"left-section__input"}>
                                    {chargeInputDisplay}
                                </div>
                    
                                {/* Miscellaneous Info */}
                                <div className={"left-section__input"}>
                                    {miscellaneousInputDisplay}
                                </div>
                            </div>

                            <div className={"input-wrapper__right-section"}>
                                {sideInputDisplay}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}